export const translationHashes = {
  "de-DE": "0f9c3790",
  "en-CA": "144d3ad2",
  "en-GB": "7b519b45",
  "en-US": "3025d5e9",
  "es-ES": "14210a43",
  "es-US": "013c88be",
  "formattings": "57aaf527",
  "fr-CA": "3a671612",
  "nl-NL": "1270efe9",
  "sv-SE": "c3dbfbde"
} as {[lang: string]: string};